module.exports = __webpack_public_path__ + "img/avatar.41485d4e.svg";